export function navigateExternal(url: string): void {
  window.location.assign(url);
}
